import { QK } from '@/js/consts/query-keys';
import { useQuery } from '@tanstack/vue-query';
import { getChannels } from './channelApi';

export const useGetChannels = () => {
    return useQuery({
        queryKey: [QK.CHANNEL.ALL],
        queryFn: async () => getChannels(),
    });
};
